import { CompanyStateChange } from "./change-company-state.model";
class ChangeCompanyStateController {
    /*@ngInject*/
    constructor($rootScope, $timeout, companyService, planService, alertsAndNotificationsService) {
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.companyService = companyService;
        this.planService = planService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
    }
    $onInit() {
        //flags
        this.changingStateFlag = false;
        this.isTrialPlanActive = false;
        this.isLoading = true;
        //variables
        this.stateText = "";
        this.assessmentsLeft;
        this.jobBoardsPullLeft;
        this.date;
        this.time;
        this.note;
        this.companyChangeStateObject = new CompanyStateChange();
        this.companyChangeStateObject.userId = this.$rootScope.userDetails.id;
        this.companyChangeStateObject.companyId = this.companyInfo.companyId;
        this.companyChangeStateObject.companyState = this.changeToState;
        this.companyChangeStateObject.techAssessmentLimitForSoftHold = 5;
        this.getCompanyPlanDetails();
        this._setDateAndTime();
        this._setStateText();
        this._setNote();
    }
    getCompanyPlanDetails() {
        this.planService.getCompanyPlanDetails(this.companyInfo.companyId, (data) => {
            if (data && data.plan) {
                this.isTrialPlanActive = data.plan == "Trial" ? true : false;
                if (this.changeToState == 'SoftHold') {
                    if (this.isTrialPlanActive) {
                        this.getAvailableAssessments();
                        this.getAvailableJobBoardsPull();
                    }
                    else {
                        this._setAssessmentLimitDefault(data.plan);
                        this.isLoading = false;
                    }
                }
                else {
                    this.isLoading = false;
                }
            }
            this.isLoading = false;
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    getAvailableAssessments() {
        var jobId = null;
        this.planService.getAvailableTechAssessmentsCount(this.companyInfo.companyId, jobId, (data) => {
            this.assessmentsLeft = data["techAssessmentsLeft"];
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    getAvailableJobBoardsPull() {
        this.planService.getAvailableJobBoardsPullCount(this.companyInfo.companyId, (data) => {
            this.jobBoardsPullLeft = data["jobBoardResumesLeftCount"];
            this.isLoading = false;
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    _setAssessmentLimitDefault() {
        this.planService.getCurrentPlan(this.companyInfo.companyId, (data) => {
            if (data.planHeaderDto.planType == 'Month to Month') {
                this.companyChangeStateObject.techAssessmentLimitForSoftHold = 10;
            }
            else {
                this.companyChangeStateObject.techAssessmentLimitForSoftHold = 25;
            }
            // this.companyChangeStateObject.jbiLimitForSoftHold = 50;
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    _setDateAndTime() {
        this.date = moment().format('ll');
        this.time = moment().format('hh:mm:ss a');
        this.$timeout(() => {
            this._setDateAndTime();
        }, 1000);
    }
    _setStateText() {
        if (this.changeToState == 'Active') {
            this.stateText = "Release";
        }
        else if (this.changeToState == 'SoftHold') {
            this.stateText = "Soft Hold";
        }
        else {
            this.stateText = this.changeToState;
        }
    }
    _setNote() {
        this.companyChangeStateObject.note = this.stateText + " Company";
    }
    changeCompanyState() {
        this.companyService.changeCompanyState(this.companyChangeStateObject, (data) => {
            this.changingStateFlag = false;
            this.alertsAndNotificationsService.showBannerMessage("Company '" + this.companyInfo.companyName + "' state changed to " + this.stateText + " successfully", 'success');
            if (this.saveCallback) {
                this.saveCallback();
            }
        }, (error) => {
            this.changingStateFlag = false;
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    cancel() {
        if (this.cancelCallback) {
            this.cancelCallback();
        }
    }
    receiveFormalizedComment(event) {
        this.companyChangeStateObject.note = event;
    }
    onVoiceTranscript(transcript) {
        if (this.companyChangeStateObject.note) {
            this.companyChangeStateObject.note += ' ' + transcript;
        }
        else {
            this.companyChangeStateObject.note = transcript;
        }
    }
}
ChangeCompanyStateController.$inject = ['$rootScope', '$timeout', 'companyService', 'planService', 'alertsAndNotificationsService'];
// import * as TEMPLATE from './change-company-state.html';
import * as TEMPLATE from 'raw-loader!./change-company-state.html';
export const ChangeCompanyStateComponent = {
    selector: 'changeCompanyState',
    component: {
        bindings: {
            companyInfo: '<',
            changeToState: '@',
            saveCallback: '&',
            cancelCallback: '&'
        },
        controller: ChangeCompanyStateController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/company/changeCompanyState/change-company-state.html'
    }
};
//# sourceMappingURL=change-company-state.component.js.map